import SectionHeading from '@/components/feature/SectionHeading';
import { siteInfo } from '@/mocks/site';

export default function TestimonialsSection() {
  return (
    <section id="voices" className="scroll-mt-24 border-y border-background-200/70 bg-background-100/45">
      <div className="mx-auto w-full px-4 py-14 md:px-10 md:py-20">
        <SectionHeading
          kicker="VOICES · 读者怎么说"
          title="42 万深夜读者，把这里当成睡前最后一站"
          description="下面的评价来自订阅用户的公开留言，未做删改。"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {siteInfo.testimonials.map((item, index) => (
            <figure
              key={item.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <i
                className={`text-2xl ${
                  index === 1 ? 'ri-double-quotes-r text-secondary-400' : 'ri-double-quotes-l text-primary-500'
                }`}
              ></i>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-300">
                {item.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/80 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500/15 font-heading text-base font-bold text-accent-300">
                  {item.initial}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-100">{item.name}</span>
                  <span className="mt-0.5 block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}